<template>
    <div class="w-100">
        <map-area-selector
            ref="areaSelector"
            :get-work-records="true"
            :contract-selected="selectedContractIds && selectedContractIds.length > 0"
            :contracts="selectedContractIds"
            :taskTypes="selectedTaskTypes"
            :order="selectedOrder"
            @areaLabelsChanged="updateAreaLabelsVisibility"
            @areaSelectionChanged="updateAreaSelection"
        />
    <div
        v-if="loading"
        id="loader"
        class="spinner"
    />
    </div>
</template>

<script>

import {restApi} from '../mixins/RestApiMixin'
import {mapHelper} from "../mixins/MapMixin";
import MapAreaSelector from "@/components/area/MapAreaSelector.vue";
import {timeUtils} from "@/components/mixins/TimeUtils";

export default {
    name: 'MapAreas',
    components: {MapAreaSelector},
    mixins: [restApi, mapHelper, timeUtils],
    props: {
        company: {
            type: Number
        },
        map: {
            type: Object,
            default: null
        },
        showLabels: {
            type: Boolean,
            default: false
        },
        drawAll: {
            type: Boolean,
            default: false
        },
        selectedContractIds: {
            type: Array,
            default() {
                return []
            }
        },
        selectedTaskTypes: {
            type: Array,
            default() {
                return []
            }
        },
        selectedOrder: {
            type: Object,
            default: null
        },
    },
    data: function () {
        return {
            loading: false,
            workRecords: [],
            areaNames: [],
            selectedAreas: []
        }
    },

    mounted() {
        if (this.drawAll) {
            this.$refs.areaSelector.fetchAreaTypes()
        }
    },

    watch: {
        map() {
            this.$nextTick(function () {
                if (this.selectedAreas && this.map) {
                    this.drawAreas(this.selectedAreas)
                }
            })
        },
        showLabels: function () {
            if(this.selectedAreas && this.map) {
                this.drawAreas(this.selectedAreas)
            }
        },
        areaCollection: function () {
            if (this.selectedContractIds && this.selectedContractIds.length === 0) {
                this.clearAreas()
                this.$refs.areaSelector.fetchAreas()
            }
            else {
                this.clearAreas()
                this.$refs.areaSelector.fetchAreaTypes()
            }
        }
    },

    beforeUnmount() {
        this.hideAreas()
    },

    methods: {
        updateAreaSelection: function (types, areas, workRecs) {
            this.workRecords = workRecs
            this.selectedAreas = areas
            if(areas && this.map) {
                this.drawAreas()
            }
        },

        updateAreaLabelsVisibility: function (visible) {
            this.$emit('updateAreaLabelsVisibility', visible)
        },

        hasAreaWorkRecord(areaId) {
            if (this.workRecords) {
                const existingRecord = this.workRecords.find(item => item.area_id === areaId)
                return existingRecord !== undefined
            }
            return false
        },


        drawAreas: function () {
            this.hideAreas()
            if (this.selectedAreas.length) {
                    this.selectedAreas.forEach(item => {
                        let rings = item.geometry.rings
                        let color = item.color ? item.color : '#404041'
                        const hasWorkRecords = this.hasAreaWorkRecord(item.id)
                        // Indicate work with green color, thicker line and higher opacity
                        color = hasWorkRecords ? '#67dc0a' : color
                        const opacity = hasWorkRecords ? 0.4 : 0.8
                        const strokeWidth = hasWorkRecords ? 3 : 1
                        this.map.drawPolygon(item.id, rings, this.AREA, color, color, opacity, strokeWidth)
                        if (this.showLabels) {
                            this.map.addAreaLabel(item.id, item.name, rings[0][0][1], rings[0][0][0])
                        }
                    })
                this.map.attachEventListenersToAreas()
                this.editingAreaEventFlag = false
                this.newPolygonId = -1
            }

        },

        hideAreas: function () {
            if (this.map) {
                this.map.removeMapItemsByType(this.AREA)
                this.map.hideAreaLabels(this.AREA)
            }
        },

        clearAreas: function () {
            this.hideAreas()
            this.selectedAreas = []
        },

        showAreaDetails(id, clickPoint) {
            let item = this.selectedAreas.find(area => area.id === id)
            let workRecords = this.workRecords.filter(item => item.area_id === id)
            if (item) {
                let bubbleContent = {}
                workRecords.forEach(work => bubbleContent[this.toLocalTime(work.time)] = work.task_type_name)
                this.map.showInfoBubbleWithAction(item.id, item.name, bubbleContent, clickPoint.lat, clickPoint.lng,
                    this.$t('areas.add_work_record'), this.onAddWork)
            }
        },

        onAddWork(areaId) {
            this.$emit('onAddWork', areaId)
        },

        refreshWorkData() {
            this.hideAreaDetails()
            this.$refs.areaSelector.fetchAreaWork()
        },

        hideAreaDetails() {
            this.map.hideInfoBubbles()
            this.map.unselectArea()
        }

    }
}
</script>
